import pkg from '../../../package.json';

export const APP_VERSION = pkg.version;
export const DEFAULT_LANG = 'fr';
export const AVAILABLE_LANG = ['en', 'fr'];
